import React from 'react'
import * as style from './Card.module.scss'

const Card = ({ sample }) => {
  const {
    // eslint-disable-next-line camelcase
    name, language, tags, icon, last_update, url,
  } = sample
  const langString = Array.isArray(language) ? language[0].toLocaleLowerCase() : language.toLocaleLowerCase()
  return (
    <a href={url} rel="noreferrer noopener" target="_blank" className={style.cardContainer}>
      <div className={style.logo}>
        <div className={style.cardIconContainer}>
          {icon !== undefined
                        // eslint-disable-next-line import/no-dynamic-require
                        && <img alt={language} src={require(`../icons/${icon}.svg`).default} />}
        </div>
      </div>
      <h2>{name}</h2>
      {/* TODO for v2 provide dynamic update date or short description */}
      {/* <p>{last_update}</p> */}
      <div>
        {tags !== undefined && tags.map((tag, id) => (
          <span key={id} className={style.label}>{tag}</span>
        ))}
      </div>
    </a>
  )
}

export default Card
